export default __webpack_public_path__ + "static/media/icon-verified-black.ee8f9b3d.svg";